import { validate } from './validate';

function getSelectedShippingKind() {
  const checked = document.querySelector(
    'input[name="shippingMethodHandle"]:checked'
  );
  if (!checked) return '';
  return (
    checked.dataset.shippingKind ||
    (checked.value === 'custom' ? 'custom' : 'quoted')
  );
}

function syncShippingMethodKind() {
  const input = document.querySelector('input[name="shippingMethodKind"]');
  if (!input) return;
  input.value = getSelectedShippingKind();
}

// toggle custom field group
function toggleCustomFieldGroup() {
  // get field group
  const fieldGroup = document.querySelector('.field-group[data-id="custom"]');
  if (!fieldGroup) return;

  // init
  let isActive = true;

  // check shipping method
  const checked = document.querySelector(
    'input[name="shippingMethodHandle"]:checked'
  );
  if (checked) {
    if (checked.value !== 'custom') {
      isActive = false;
    }
  } else {
    isActive = false;
  }

  fieldGroup.style.display = isActive ? '' : 'none';
}

// toggle residential field group
function toggleResidentialFieldGroup() {
  // get field group
  const fieldGroup = document.querySelector(
    '.field-group[data-id="residential"]'
  );
  if (!fieldGroup) return;

  // init
  let isActive = true;

  // check address type
  const addressType = document.querySelector('input[name="addressType"]').value;
  if (addressType !== 'residential') {
    isActive = false;
  }

  fieldGroup.style.display = isActive ? '' : 'none';
}

// toggle commercial field group
function toggleCommercialFieldGroup() {
  // get field group
  const fieldGroup = document.querySelector(
    '.field-group[data-id="commercial"]'
  );
  if (!fieldGroup) return;

  // init
  let isActive = true;

  // check address type
  const addressType = document.querySelector('input[name="addressType"]').value;
  if (addressType !== 'commercial') {
    isActive = false;
  }

  fieldGroup.style.display = isActive ? '' : 'none';
}

// Show/hide transit cover shipping methods
function toggleTransitCoverShippingMethods() {
  // get input
  const input = document.querySelector('[name="fields[transitCover]"]:checked');
  const value = input ? input.value : 'yes';
  const useTransitCover = value === 'yes';

  // show/hide transit cover shipping methods
  const shippingMethods = document.querySelectorAll(
    '[name="shippingMethodHandle"][data-shipping-kind="quoted"]'
  );
  shippingMethods.forEach((method) => {
    const title = method.closest('.radio').textContent;
    let active = false;
    if (title.toLowerCase().includes('transit cover')) {
      active = useTransitCover;
    } else {
      active = !useTransitCover;
    }
    const radioCard = method.closest('.radio-card');
    if (radioCard) {
      if (!active && method.checked) {
        method.checked = false;
      }
      radioCard.style.display = active ? '' : 'none';
    }
  });

  toggleResidentialFieldGroup();
  toggleCommercialFieldGroup();
  toggleCustomFieldGroup();
}

document.addEventListener('DOMContentLoaded', function () {
  // Validate the form
  validate(document.getElementById('checkout_shipping'), {
    rules: {
      'fields[transitCover]': ['required'],
      shippingMethodHandle: ['required'],
      'fields[customShippingMethod]': [
        ['requiredIf', 'shippingMethodHandle', 'custom'],
      ],
      // 'fields[customerComments]': [
      //   ['requiredIf', 'shippingMethodHandle', 'custom'],
      // ],
      'fields[deliveryTime][]': [['requiredIf', 'addressType', 'commercial']],
      'fields[authorityToLeave][]': [
        ['requiredIf', 'addressType', 'residential'],
      ],
    },
  });

  // Show/hide the custom field group
  const shippingMethodInputs = document.querySelectorAll(
    'input[name="shippingMethodHandle"]'
  );
  shippingMethodInputs.forEach((input) => {
    input.addEventListener('change', () => {
      syncShippingMethodKind();
      toggleCustomFieldGroup();
      toggleResidentialFieldGroup();
      toggleCommercialFieldGroup();
    });
  });

  // Show/hide transit cover shipping methods
  const transitCoverInputs = document.querySelectorAll(
    'input[name="fields[transitCover]"]'
  );
  transitCoverInputs.forEach((input) => {
    input.addEventListener('change', () => {
      toggleTransitCoverShippingMethods();
    });
  });

  // init show/hide field groups
  syncShippingMethodKind();
  toggleCustomFieldGroup();
  toggleResidentialFieldGroup();
  toggleCommercialFieldGroup();
  toggleTransitCoverShippingMethods();
});
